<template>
  <div class="input_container">
    <van-field v-model="inputValue" right-icon="user-circle-o"
      :style="{ border: props.isShowError ? '1.5px red solid' : '0.5px solid #65436f' }"
      :type="isShow && props.isPassword ? 'text' : props.fieldType" :maxlength="props.isPassword ? 20 : 'none'"
      :placeholder="props.labelText">
      <template #right-icon>
        <div v-if="props.isPassword">
          <img v-if="isShow" src="@/assets/loginRegister/showEye.png" alt="" width="18px" class="iconImage"
            @click="handleShowPassword" />
          <img v-else src="@/assets/loginRegister/hideEye.png" alt="" width="18px" class="iconImage"
            @click="handleShowPassword" />
        </div>
        <div v-if="props.isOTP">
          <div class="sendOTP" v-if="isLoading">
            <van-loading type="spinner" size="15"/>
          </div>
          <div class="sendOTP" v-else-if="isCounting">
            {{ `${countdown}s` }}
          </div>
          <div v-else class="sendOTP" @click="getOTP">
            {{ $t('loginRegister.sendCode') }}
          </div>
        </div>
      </template>

      <template #left-icon>
        <div class="leftContainer" v-if="!props.isPassword && props.isshowFlag">
          <img src="@/assets/themetwo/brazil_flag.png" alt="" />
          <p class="currencyText">+55</p>
          <!-- <div class="line"></div> -->
        </div>
        <div v-if="props.isPassword" class="leftContainer">
          <img src="@/assets/themetwo/lock.png" alt="" width="18px">
        </div>
        <div class="leftContainer" v-if="props.fieldType == 'email'">
          <img src="@/assets/loginRegister/email.png" alt="" width="18px">
        </div>
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, watch, defineEmits, defineExpose } from 'vue'
import type { FieldType } from 'vant'
import { COUNT_DOWN_TIME, startCountdownCommon } from '@/view/loginRegister/supportScript'

const props = defineProps({
  fieldType: {
    type: String as () => FieldType,
    default: () => 'text'
  },
  isPassword: {
    type: Boolean,
    default: () => false
  },
  labelText: {
    type: String,
    default: () => ''
  },
  isshowFlag: {
    type: Boolean,
    default: () => false
  },
  isShowError: {
    type: Boolean,
    default: () => false
  },
  isOTP: {
    type: Boolean,
    default: () => false
  }
})

const isShow = ref(false)
const inputValue = ref('')
const countdown = ref(COUNT_DOWN_TIME)
const isCounting = ref(false)
const isLoading = ref(false)
let timer: ReturnType<typeof setInterval> | null = null
const emit = defineEmits(['valueChanged', 'getOtp'])


watch(() => inputValue.value, (newValue: string) => {
  emit('valueChanged', newValue)
});

const handleShowPassword = () => {
  isShow.value = !isShow.value
}

const getOTP = () => {
  isLoading.value = true
  emit('getOtp')
}

const loadingFalse = () => {
  isLoading.value = false
}

let clearCountdown: (() => void) | null = null
const startCountdown = () => {
  clearCountdown?.()
  clearCountdown = startCountdownCommon(countdown, isCounting)
}
defineExpose({
  startCountdown,
  loadingFalse
})
</script>
<style scoped>
.input_container>>>.van-field {
  border-radius: 10px;
  background: #2c1d31;
  /* border: 0.5px solid #65436f; */
  color: #ffffffd9;
  padding: 8px 15px !important;
  margin-top: 10px;
  height: 43.32px;
  font-size: 17px;

}

.input_container>>>.van-field__control {
  color: #fff !important;
  padding-left: 10px !important;
}

.input_container>>>.van-field__control::placeholder {
  color: #ffffff40 !important;
  font-family: monospace;
}

.input_container>>>.van-field__right-icon {
  color: #ffffff40 !important;
  line-height: 0px;
}

.leftContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.currencyText {
  color: #fff;
  font-family: monospace;
  padding: 0 5px;
  margin: 0;
}

.leftContainer img {
  width: 25px;
}

.line {
  width: 1px;
  background-color: rgba(255, 255, 255, 0.65);
  height: 15px;
  margin-right: 5px;
}

.sendOTP {
  background-image: linear-gradient(180deg,#ff3d9e,#fd66b1);
  padding: 12px 10px;
  color: #fff;
  border-radius: 10px;
  min-width: 8vh;
  text-align: center;
  font-size: 13px;
}
</style>